import * as ActionTypes from '../constants/actionsTypes';

class ChangesQueue {
  constructor() {
    this.queue = [];
    this.onAdd = null;
  }

  addChange(change) {
    let updateIndex = this.updateActionAt(change);
    while (updateIndex !== -1) {
      this.queue.splice(updateIndex, 1);
      updateIndex = this.updateActionAt(change);
    }

    const item = new Promise((resolve, reject) => {
      this.queue.push({ item: change, onSuccess: resolve, onError: reject });
    });

    if (this.onAdd) {
      this.onAdd(change);
    }

    return item;
  }

  getChanges(count = 1) {
    return this.queue.splice(0, count);
  }

  getAllChanges() {
    return this.getChanges(this.length);
  }

  isEmpty() {
    return this.length === 0;
  }

  get length() {
    return this.queue.length;
  }

  updateActionAt(change) {
    return this.queue.map(q => q.item).findIndex(this.isReplacable(change));
  }

  isReplacable = replacer => replacable =>
    (replacer.entityType === replacable.entityType &&
    replacable.actionType === ActionTypes.UPDATE &&
      replacer.prevValue.id === replacable.nextValue.id) ||
    (replacer.actionType === ActionTypes.DELETE &&
      replacable.dependencies &&
      replacable.dependencies.has(replacer.entityType) &&
      replacable.dependencies.get(replacer.entityType) === replacer.prevValue.id);

  registerOnAddHandler = func => {
    this.onAdd = func;
  };
}

export default new ChangesQueue();
